module.exports = __webpack_public_path__ + "img/xici.463b6c4b.svg";